// import Home from '@/views/fdback/home'
const Home = () => import('@/views/fdback/home')
// import Introduced from '@/views/fdback/introduce'
const Introduced = () => import('@/views/fdback/introduce')
export default [
    {
        path: '',
        component: Home,
        meta: {
            title: '帮助与反馈'
        }
    },
    {
        path: 'uxintro',
        name: 'Introduced',
        component: Introduced,
        meta: {
            title: '使用帮助'
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/fdback.js